/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file useAsync root reducer
 * @author Roland Scott
 * @module react-async-hook\internal\state\reducers\root-reducer
 */

import { IAsyncState, IAction } from "../types";
import { finish } from "./finish";
import { ignore } from "./ignore";
import { reset } from "./reset";
import { start } from "./start";

/**
 * Convert take the old state, and action and return a new state.
 * @param prevState The old async state
 * @param action The action that's being dispatched
 * @return The new async state
 */
export function rootReducer(prevState: IAsyncState, action: IAction): IAsyncState {
	switch (action.type) {
		case "finish":
			return finish(prevState, action.id!, action.result, action.error);
		case "ignore":
			return ignore(prevState, action.id!);
		case "reset":
			return reset();
		case "start":
			return start(prevState, action.id!);
		default:
			return prevState;
	}
}
